import { createFileRoute } from '@tanstack/react-router'
import { PaymentsListPage } from '@/features/payments/payments-list-page'
import { requirePermission } from '@/lib/route-guards'

/** Pagos registrados: listado con filtros, total y exportación. */
export const Route = createFileRoute('/_app/payments/')({
  beforeLoad: requirePermission('payments:read'),
  component: PaymentsListPage,
})
